import features from '../../../shared/features'
import { debounce } from '../../../shared/functions'

const defaults = {
  sensitivity: 20,
  startCapturingAfter: 1000,
}

export function bounceWatcher(callback: () => void, root = document.documentElement, options = defaults) {
  const debouncedCallback = debounce(callback, 100)
  const onMouse = (e: MouseEvent) => {
    if (e.clientY < options.sensitivity) {
      debouncedCallback()
    }
  }

  const onKeyboard = (e: KeyboardEvent) => {
    if ((e.metaKey || e.ctrlKey) && e.keyCode === 76) {
      callback()
    }
  }

  const handlerOptions = features().events.passiveSupported ? { passive: true, capture: true } : true

  setTimeout(() => {
    root.addEventListener('mouseout', onMouse, handlerOptions)
    root.addEventListener('keydown', onKeyboard, handlerOptions)
  }, options.startCapturingAfter)
}
